import { apiPost } from '../api'

export const get_performance = data => {
  return apiPost({
    endpoint: 'attendance/get_performance',
    data: data
  })
}
